import { Field, Float, ID, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { ActionArgs } from '../../action/ActionArgs'
import type { CreditAccount } from './CreditAccount'

@InputType()
export class IncrementBalanceArgs extends ActionArgs {
  /** Generic owner of the balance — a `User._id` or `Tenant._id`, per `resolveBillingOwnerId`. */
  @Field(() => ID)
  ownerId: string

  /** Signed delta applied to the balance — negative to debit, positive to grant. */
  @Field(() => Float)
  delta: number

  /** Seeds a fresh account via `$setOnInsert` when the owner has no `CreditAccount` yet. */
  @Field(() => GraphQLJSON, { nullable: true })
  createIfMissing?: { currency: string }
}

/**
 * Atomically applies `delta` to an owner's `CreditAccount.balance` and returns the
 * resulting document — the sole caller of `CreditAccountRepository`'s atomic increment,
 * so `DebitCredits`/`GrantCredits` depend on this Action rather than reaching into a
 * repository-specific method directly. Internal to `ai-node`, injected by class only.
 */
export interface IIncrementBalance {
  execute(args: IncrementBalanceArgs): Promise<CreditAccount | null>
}
